import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Home, Mail, Briefcase } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page introuvable - Croissance 🥐consulting</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="min-h-[60vh] flex items-center justify-center px-4 py-16">
        <div className="max-w-2xl mx-auto text-center">
          {/* 404 Badge */}
          <div className="inline-flex items-center justify-center w-20 h-20 mb-6 rounded-full bg-[#FBF7EF] border-2 border-[#B65C3A]">
            <span className="text-3xl font-bold text-[#B65C3A]">404</span>
          </div>

          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl font-bold text-[#4A3A2A] mb-4">
            Page introuvable
          </h1>

          {/* Description */}
          <p className="text-lg text-[#2D2D2D] mb-8 max-w-md mx-auto">
            Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
          </p>

          {/* Navigation Links */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#B65C3A] text-white rounded-lg hover:bg-[#9d4d2f] transition-colors font-medium"
            >
              <Home className="w-5 h-5" />
              Retour à l'accueil
            </Link>

            <Link
              to="/offres"
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-[#B65C3A] text-[#B65C3A] rounded-lg hover:bg-[#FBF7EF] transition-colors font-medium"
            >
              <Briefcase className="w-5 h-5" />
              Voir nos offres
            </Link>

            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-[#6B7A3A] text-[#6B7A3A] rounded-lg hover:bg-[#FBF7EF] transition-colors font-medium"
            >
              <Mail className="w-5 h-5" />
              Nous contacter
            </Link>
          </div>

          {/* Decorative Element */}
          <div className="mt-12 text-6xl">🥐</div>
        </div>
      </div>
    </>
  );
}
